import { render, staticRenderFns } from "./AutonomousTeachingActivityForm.vue?vue&type=template&id=4807d652&scoped=true"
import script from "./AutonomousTeachingActivityForm.vue?vue&type=script&lang=js"
export * from "./AutonomousTeachingActivityForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=4807d652&prod&scoped=true&lang=css&external"
import style1 from "./AutonomousTeachingActivityForm.vue?vue&type=style&index=1&id=4807d652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4807d652",
  null
  
)

export default component.exports